export const validatePhone = /^(\+0?1\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/;
export const validateZipCode = /^\s*?\d{5}(?:[-\s]\d{4})?\s*?$/;
export const validateOptionalZipCode = /^$|^\s*?\d{5}(?:[-\s]\d{4})?\s*?$/;
export const validateHexColor = /^#+([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/;
